export default __webpack_public_path__ + "static/media/drag_image.97cd2a60.png";